import React, { useState } from 'react';
import { Mail, Lock, Github, Eye, EyeOff } from 'lucide-react';
import { Link, useNavigate } from 'react-router-dom'
import api from "./../api"
import { useToaster } from '../Context/ToasterContext'
import { useAuth } from '../Context/AuthContext'
import Navbar from './../Components/NavBar/NavBar'
import Footer from "./../Components/LandingPage/Footer"
import Bg from '../Components/background/Bg'

const LoginPage = () => {
    const [showPassword, setShowPassword] = useState(false);
    const {addToaster, removeToaster}  = useToaster()
    const [crendentials, setCrendentials] = useState({
        email: "",
        password: "",
    });
    const {auth, setAuth} = useAuth()
    const navigate = useNavigate();
    
    const togglePasswordVisibility = () => {
        setShowPassword(!showPassword);
    };
    
    const handleChange = (e) => {
        setCrendentials({
            ...crendentials,
            [e.target.name]: e.target.value,
        })
    }
    
    const handleSubmit = (e) => {
        e.preventDefault();
        addToaster("Checking Credentials",100);
        api.post("/auth/login",{
            email: crendentials.email,
            password: crendentials.password,
        }).then(res => {
            const response = res.data;
            if(response.statusCode !== 200){
                addToaster(response.message, response.statusCode);
            }else{
                addToaster(response.message, response.statusCode);
                setTimeout(() => {
                    setAuth({
                        id: response.id,
                        role: response.role,
                    })
                    sessionStorage.setItem("accessToken", response.jwtToken);
                    navigate("/dashboard");
                },[1000])
            }
        }).finally(() => {
            setTimeout(() => {
                removeToaster();
            },[3000])
        })
    }
    
    return (
        <div className="min-h-screen bg-base-200 flex  flex-col items-center justify-center p-4 relative">
            <Navbar page="loginPage"/>
            <Bg />
            <div className="w-full max-w-md lg:max-w-lg bg-base-100 rounded-2xl shadow-xl p-8 absolute z-[10] border border-neutral">
                
                <div className="text-center mb-8">
                    <h1 className="text-3xl font-bold text-primary">Welcome Back</h1>
                    <p className="text-base-content/70 mt-2">Sign in to your account</p>
                </div>
                
                
                <form className="space-y-6" onSubmit={handleSubmit}>
                    <div>
                        <label className="block text-sm font-medium text-base-content mb-2">
                            Email Address
                        </label>
                        <div className="relative">
                            <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
                                <Mail size={18} className="text-base-content/50" />
                            </div>
                            <input
                                type="email"
                                placeholder="you@example.com"
                                className="w-full py-3 pl-10 pr-4 bg-base-200 border-0 rounded-lg focus:ring-2 focus:ring-primary focus:outline-none"
                                required
                                name="email"
                                onChange={handleChange}
                            />
                        </div>
                    </div>
                    
                    <div>
                        <div className="flex items-center justify-between mb-2">
                            <label className="block text-sm font-medium text-base-content">
                                Password
                            </label>
                        </div>
                        <div className="relative">
                            <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
                                <Lock size={18} className="text-base-content/50" />
                            </div>
                            <input
                                type={showPassword ? "text" : "password"}
                                placeholder="••••••••"
                                className="w-full py-3 pl-10 pr-12 bg-base-200 border-0 rounded-lg focus:ring-2 focus:ring-primary focus:outline-none"
                                required
                                name="password"
                                onChange={handleChange}
                            />
                            <button
                                type="button"
                                className="absolute inset-y-0 right-0 pr-3 flex items-center"
                                onClick={togglePasswordVisibility}
                                tabIndex="-1"
                            >
                                {showPassword ? (
                                    <EyeOff size={18} className="text-base-content/70 hover:text-base-content" />
                                ) : (
                                    <Eye size={18} className="text-base-content/70 hover:text-base-content" />
                                )}
                            </button>
                        </div>
                    </div>
                    
                    <div>
                        <button
                            type="submit"
                            className="w-full bg-primary hover:bg-primary-focus text-primary-content py-3 rounded-lg font-medium transition-colors duration-300"
                        >
                            Sign in
                        </button>
                    </div>
                </form>
                
                
                <div className="flex items-center my-6">
                    <div className="flex-grow border-t border-base-300"></div>
                    <span className="px-4 text-sm text-base-content/60">OR CONTINUE WITH</span>
                    <div className="flex-grow border-t border-base-300"></div>
                </div>
                
                
                <div className="grid grid-cols-2 gap-4">
                    <button className="flex items-center justify-center gap-2 bg-base-100 hover:bg-base-200 text-base-content py-3 px-4 rounded-lg border border-base-300 transition-colors duration-300">
                        <svg viewBox="0 0 24 24" className="w-5 h-5" xmlns="http://www.w3.org/2000/svg">
                            <path d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92c-.26 1.37-1.04 2.53-2.21 3.31v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.09z" fill="#4285F4" />
                            <path d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z" fill="#34A853" />
                            <path d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l2.85-2.22.81-.62z" fill="#FBBC05" />
                            <path d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z" fill="#EA4335" />
                        </svg>
                        <a className="font-medium" href={process.env.REACT_APP_GOOGLE_API_ENDPOINT}>Google</a>
                    </button>
                    
                    <button className="flex items-center justify-center gap-2 bg-base-100 hover:bg-base-200 text-base-content py-3 px-4 rounded-lg border border-base-300 transition-colors duration-300">
                        <Github size={20} />
                        <a className="font-medium" href={process.env.REACT_APP_GITHUB_API_ENDPOINT}>GitHub</a>
                        
                    </button>
                </div>
                
                
                <div className="text-center mt-8">
                    <p className="text-base-content">
                        Don't have an account?
                        <Link to="/signup" className="text-primary hover:text-primary-focus font-medium ml-1">
                            Create an account
                        </Link>
                    </p>
                </div>
            </div>
            {/*<Footer />*/}
        </div>
    );
};

export default LoginPage;